export enum TaskType {
  RetrieveWillPacket = 0,
  SendConfirmationLetter,
}
